<template>
  <div>
    <div class="section">
      <h3 class="section-title">
        <span>Új kampány</span>
        <pool-state :has-results="hasResults"></pool-state>
      </h3>
      <div class="section-content">
        <b-form-group>
          <template v-slot:label>
            <span class="border-right pr-2">Kontrol tárgy</span><span class="small ml-2">Add meg az optimalizálandó tárgyat!</span>
          </template>
          <b-input-group class="d-flex align-items-center">
            <b-form-input
              v-model="control"
              v-if="!hasResults"
              required
              type="text"
            />
            <div class="form-control" v-if="hasResults" readonly>
              <span v-html="formattedControl"></span>
            </div>
            <b-input-group-append class="ml-2">
              <b-button
                v-if="!hasResults"
                :disabled="control.length < 10 || loading"
                @click="getResults"
              >
                Teszt indítása
              </b-button>
              <b-button
                v-if="hasResults"
                variant="link text-danger"
                :disabled="loading"
                @click="reset"
                v-b-tooltip.hover title="Megváltoztatom"
              >
                <i class="fas fa-edit"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="section" v-if="hasResults">
        <div class="section-title d-flex">
          <h3 class="border-right pr-2 mb-0">Tárgyelemzés eredménye</h3>
          <div class="small ml-2 align-self-center">
            <p class="mb-0">Hatékonyabb eredmények érdekében ne a kontroll tárgyat változtasd,</p>
            <p class="mb-0">hanem építsd be a következő dimenziókat javaslatokba.</p>
          </div>
        </div>
        <div class="section">
          <dimensions class="my-4" :categories="dimensionCategories"  :series="controlDimensions">
            <template v-slot:footer>
              <div class="mt-4" v-if="controlScore > -1">
                <span class="text-info fs-180 mr-3">Összesített eredmény:</span>
                <star-rating class="d-inline-block" :value="controlScore"/>
              </div>
            </template>
          </dimensions>
        </div>
      </div>
      <div v-show="loading" style="height: 300px" class="p-5">
        <div class="d-flex justify-content-center">
          <b-spinner
            variant="info"
            label="Betöltés"
            :style="{width: '5rem', height: '5rem', 'margin-top': `calc((300px - 18rem) / 2)`}"
          />
        </div>
      </div>
      <div class="section" v-if="hasResults">
        <div class="section-title d-flex">
          <h3 class="border-right pr-2 mb-0">Tárgy tesztelési javaslatok</h3>
          <div class="small ml-2 align-self-center">
            <p class="mb-0">Javaslatok alapján hozd létre a tárgy különböző variációit.</p>
            <p class="mb-0">Fontos, hogy a tárgyban csak a javaslatoknak megfelelően végezz változtatásokat.</p>
          </div>
        </div>
        <div class="section" v-if="hasResults">
          <div class="mt-3">
            <div
              v-for="(test, key) in tests"
              :key="key"
              class="d-flex align-items-center mb-3"
            >
              <testcampaign-test
                class="w-100"
                :subject.sync="test.subject"
                :test="test"
                :categories="dimensionCategories"
                @rate-test="rateTest"
              />
            </div>
            <div class="d-flex mt-5">
              <div class="flex-fill">
                <b-button
                  v-if="hasResults"
                  variant="secondary"
                  @click="save(false)"
                > <!-- class="btn btn-secondary mx-auto" -->
                  Ment és kilép
                </b-button>
              </div>
              <div>
                <b-button
                  v-if="hasResults"
                  variant="info"
                  :disabled="!state || saving"
                  @click="save(true)"
                > <!-- class="btn btn-info mx-auto" -->
                  VÉGLEGESÍT
                  <i class="fas fa-caret-right" />
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .label {
      text-transform: uppercase;
      font-size: 120%;
      color: var(--lingusta-green);
  }
</style>
<script>
import Test from './Test.vue'
import Dimensions from './partials/Dimensions'
import StarRating from './partials/StarRating'
import PoolState from './partials/PoolState'

import { dimensions } from '../../utils/Dimensions'
import { computeTestLabel, sortTests } from '../../util'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

export default {
  mixins: [
    ErrorHandler()
  ],
  components: {
    'pool-state': PoolState,
    'star-rating': StarRating,
    'testcampaign-test' : Test,
    'dimensions': Dimensions
  },
  props: {
    testCampaign: {
      type: Object,
      default: () => ({
        id: -1,
        name: '',
        tests: [],
        suggestions: {
          expectedOpenRate: 0,
          achievableOpenRate: 0
        }
      })
    },
    subject: {
      type: String,
      default: ''
    },
    score: {
      type: Number,
      default: -1
    },
    dimensions: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      control: '',
      controlDimensions: [],
      controlScore: -1,
      hasResults: false,
      campaign: {
        id: -1,
        name: '',
        suggestions: {
          expectedOpenRate: 0,
          achievableOpenRate: 0
        }
      },
      tests: [],
      state: false,
      formattedControl: '',
      loading: false,
      saving: false,
    }
  },
  computed: {
    dimensionCategories() {
      return dimensions
    },
  },
  watch: {
    testCampaign : {
      deep: true,
      immediate: true,
      handler(campaign) {
        this.campaign = _.assign(campaign)
      }
    },
    'campaign.tests': {
      immediate: true,
      deep: true,
      handler(tests) {
        var tests = _.drop(tests)
        this.tests = _.map(tests, (test, index) => ({
          ...test,
          state: test.subject.length > 9,
          label: computeTestLabel(index, tests.length, false),
          rating: false,
          rated: test.score > -1 && test.dimensions.length > 0,
          index: index
        }))
      }
    },
    tests: {
      deep: true,
      handler(tests) {
        this.state = _.reduce(tests, (result, test) => {
          return result && test.subject.length > 9
        }, true)

        _.forEach(tests, (test, index) => {
          if(this.campaign.tests[index + 1].subject !== test.subject) {
            // if the subject has changed reset rating
            test.score = -1
            test.dimensions = []
            test.rating = false
            test.rated = false
          }
          this.campaign.tests[index + 1] = _.assign({}, test)
        })
      }
    },
    control: function(newSubject) {
      this.campaign.name = newSubject
    },
  },
  mounted() {
    this.control = this.subject
    this.controlScore = this.score
    this.controlDimensions = this.dimensions
    this.formattedControl = this.subject

    if(this.campaign.id === -1) {
      this.hasResults = false
      this.$router.push('/tc/create')
    } else {
      this.state = true
      this.hasResults = true
    }
  },
  methods: {
    rateTest(test) {
      test.score = -1
      test.rated = false
      test.rating = true

      this.$http.post(this.$url('api.test-campaigns.rate-subject'),  { subject: test.subject} )
        .then(({data}) => {
          test.score = data.rating.score
          test.dimensions = data.rating.dimensions
          test.rated = true
        })
        .catch((err) => {
          this.errors = this.handleErrors(err)
        })
        .finally(()=> {
          test.rating = false
        })
    },
    getResults() {
      this.loading = true
      this.$http.post(this.$url('api.test-campaigns.predict-open-rate'),  { subject: this.control} )
        .then(({data}) => {
          if(data) {
            _.assign(this.campaign.suggestions, data.prediction)
            this.campaign.tests = data.tests
            this.formattedControl = data.prediction.htmlFormattedSubject
            this.controlScore = data.score
            this.controlDimensions = data.dimensions

            this.hasResults = true
            this.$router.push('/tc/edit')
          } else {
            this.hasResults = false
          }
        })
        .catch((err) => {
          this.errors = this.handleErrors(err)
        })
        .finally(()=> {
          this.loading = false
        })
    },
    save(finalized) {
      this.saving = true
      var id = -1
      this.$http.post(this.$url('api.test-campaigns.store'), this.campaign)
        .then(({data}) => {
          id = data.testcampaign.id
          this.$emit('update:testCampaign', data.testcampaign)
        })
        .catch((err) => {
          this.errors = this.handleErrors(err)
          this.saving = false
        })
        .finally(() => {
          if(id == -1) {
            return
          }

          if (finalized) {
            let url = this.$url('test-campaigns.edit', id) + '#/tc/finalize'
            window.location.href = url
          } else {
            window.location.href = this.$url('test-campaigns.index')
          }
        })
    },
    reset() {
      this.hasResults = false
      this.state = false
      this.campaign.name = this.control
      this.campaign.tests = []
      this.campaign.suggestions = {
        expectedOpenRate: 0,
        achievableOpenRate: 0
      }
      this.$router.push('/tc/create')
    }
  }
}
</script>